import { CustomIconProps } from 'assets/Icons/LibraryIcon';
import React from 'react';

const RewindIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? 40}
      height={height ?? 40}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M20 36.6641C17.9167 36.6641 15.9653 36.2682 14.1458 35.4766C12.3264 34.6849 10.7431 33.6155 9.39583 32.2682C8.04861 30.921 6.97917 29.3377 6.1875 27.5182C5.39583 25.6988 5 23.7474 5 21.6641H8.33333C8.33333 24.9141 9.46528 27.671 11.7292 29.9349C13.9931 32.1988 16.75 33.3307 20 33.3307C23.25 33.3307 26.0069 32.1988 28.2708 29.9349C30.5347 27.671 31.6667 24.9141 31.6667 21.6641C31.6667 18.4141 30.5347 15.6571 28.2708 13.3932C26.0069 11.1293 23.25 9.9974 20 9.9974H19.75L22.3333 12.5807L20 14.9974L13.3333 8.33073L20 1.66406L22.3333 4.08073L19.75 6.66406H20C22.0833 6.66406 24.0347 7.0599 25.8542 7.85156C27.6736 8.64323 29.2569 9.71267 30.6042 11.0599C31.9514 12.4071 33.0208 13.9905 33.8125 15.8099C34.6042 17.6293 35 19.5807 35 21.6641C35 23.7474 34.6042 25.6988 33.8125 27.5182C33.0208 29.3377 31.9514 30.921 30.6042 32.2682C29.2569 33.6155 27.6736 34.6849 25.8542 35.4766C24.0347 36.2682 22.0833 36.6641 20 36.6641ZM15 26.6641V19.1641H12.5V16.6641H17.5V26.6641H15ZM20.8333 26.6641C20.3611 26.6641 19.9653 26.5043 19.6458 26.1849C19.3264 25.8655 19.1667 25.4696 19.1667 24.9974V18.3307C19.1667 17.8585 19.3264 17.4627 19.6458 17.1432C19.9653 16.8238 20.3611 16.6641 20.8333 16.6641H24.1667C24.6389 16.6641 25.0347 16.8238 25.3542 17.1432C25.6736 17.4627 25.8333 17.8585 25.8333 18.3307V24.9974C25.8333 25.4696 25.6736 25.8655 25.3542 26.1849C25.0347 26.5043 24.6389 26.6641 24.1667 26.6641H20.8333ZM21.6667 24.1641H23.3333V19.1641H21.6667V24.1641Z'
        fill={fill ?? 'white'}
      />
    </svg>
  );
};

export default RewindIcon;
